import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { paddingLevel, Points } from '@styles';
import { Title } from '@components/Title';
import { BlogCards } from '@components/Blog-Cards';
import { Navigation, Bottom } from './organism';
import { useTranslations } from '@libs/translations';

export const BlogPage = ({ articles = [], navigations = [], pageCount = 0, currentCategory }) => {
  const translations = useTranslations();
  const router = useRouter();
  const {
    pathname,
    query: { page, category },
  } = useRouter();
  const currentPage = page ? Number(page) : 1;

  const onChangePage = (page) => {
    const params = {};

    if (page !== 1) {
      params.page = page;
    }

    if (currentCategory !== 'all') {
      params.category = category;
    }

    router.push({
      pathname,
      query: params,
    });
  };

  return (
    <Container>
      <Wrapper>
        <Title>{translations.t('site.blog.pageTitle')}</Title>
        <Navigation navigations={navigations} currentCategory={currentCategory} />
        <BlogCards cards={articles} />
        <Bottom pageCount={pageCount} currentPage={currentPage} onChangePage={onChangePage} />
      </Wrapper>
    </Container>
  );
};

const Container = styled.section`
  ${paddingLevel('bottom', 'colar')};
  max-width: 1440px;
  margin: 0 auto;
  padding-top: 65px;

  @media ${Points.tablet_portrait} {
    padding-top: 80px;
  }

  @media ${Points.laptop} {
    padding-top: 60px;
  }

  @media ${Points.fullhd} {
    padding-top: 70px;
  }
`;

const Wrapper = styled.div`
  ${Grid.post(2)};
  ${Grid.push(2)};
`;
